import { render } from "./SearchWithDropdown.vue?vue&type=template&id=08f24ab0"
import script from "./SearchWithDropdown.vue?vue&type=script&lang=js"
export * from "./SearchWithDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__